export enum EntityType {
  Team = 'team',
  League = 'league',
  Event = 'event',
  State = 'state',
  ReadableId = 'readable-id',
  Video = 'video',
  News = 'news',
}
